/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Feature_Team_CreditsInputs */



/**
* | output |
* | --- |
* | "€5/user monthly credit pool" |
*
* @param {Plan_Feature_Team_CreditsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_feature_team_credits = /** @type {((inputs?: Plan_Feature_Team_CreditsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Feature_Team_CreditsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("€5/Nutzer monatlicher Credit-Pool")
	return /** @type {LocalizedString} */ ("€5/user monthly credit pool")
});